import { Navigate } from "react-router-dom";
import ErrorPage from "../components/errorPage/errorPage";
import ProtectedAdminRoute from "../components/protectedAdminRoute/protectedAdminRoute";
import { PharmaFormFieldsProvider } from "../context/pharmaFormFieldsContext";
import ClientConfiguration from "../pages/clientConfiguration/clientConfiguration";
import CmmOrder from "../pages/cmmOrder/cmmOrder";
import Configurations from "../pages/configurations/configurations";
import DocumentsToAttach from "../pages/configurations/pages/documentsConfiguration/documentsToAttach";
import FormConfig from "../pages/configurations/pages/formsConfiguration/formConfig";
import FormConfigurationLayout from "../pages/configurations/pages/formsConfiguration/formConfigurationLayout";
import SingleFormConfiguration from "../pages/configurations/pages/formsConfiguration/singleFormConfiguration/singleFormConfiguration";
import HealthFacilityConfiguration from "../pages/configurations/pages/healthFacilityConfiguration/healthFacilityConfiguration";
import MedicineNameConfiguration from "../pages/configurations/pages/medicineNameConfiguration/medicineNameConfiguration";
import NarAgentGridLayout from "../pages/configurations/pages/narAgentGrid/narAgentGridLayout";
import PaFormConfiguration from "../pages/configurations/pages/paFormConfiguration/paFormConfiguration";
import ClinicalQuestionnaire from "../pages/configurations/pages/pharmaPaConfiguration/pages/clinicalQuestionnaire/clinicalQuestionnaire";
import DrugsConfiguration from "../pages/configurations/pages/pharmaPaConfiguration/pages/drugConfig/drugsConfig";
import PayerConfiguration from "../pages/configurations/pages/pharmaPaConfiguration/pages/payerConfiguration/payerConfiuratiom";
import PbmConfiguration from "../pages/configurations/pages/pharmaPaConfiguration/pages/pbmConfiguration/pbmConfiguration";
import ProviderList from "../pages/configurations/pages/pharmaPaConfiguration/pages/providerList/providerList";
import SendToPlanConfig from "../pages/configurations/pages/pharmaPaConfiguration/pages/sendToPlanConfig/sendToPlanConfig";
import PharmaPaConfigurationLayout from "../pages/configurations/pages/pharmaPaConfiguration/pharmaPaConfigurationLayout";
import PrescriptionParsingConfiguration from "../pages/configurations/pages/prescriptionParsingConfiguration/prescriptionParsingConfiguration";
import RpaConfiguration from "../pages/configurations/pages/rpaConfiguration/rpaConfiguration";
import CredentialsConfig from "../pages/credentialsConfigration/credentialsConfig";
import InsuranceDetailsLayout from "../pages/insuranceDetails/insuranceDetailsLayout";
import InternalProcessedOrderStatus from "../pages/internalProcessedOrderStatus/internalProcessedOrderStatus";
import PharmaPaDiffDataLayout from "../pages/pharmaPaDiffData/pharmaPaDiffDataLayout";
import PharmaPaDiffViewer from "../pages/pharmaPaDiffViewer/pharmaPaDiffViewer";
import PharmaPaFormLayout from "../pages/pharmaPaForm/pharmaPaFormLayout";
import PharmaPaWorklistLayout from "../pages/pharmaPaWorklist/pharmaPaWorklistLayout";
import PharmaQuestionaireLayout from "../pages/pharmaQuestionaire/pharmaQuestionaireLayout";
import Members from "../pages/settings/members/members";
import Profile from "../pages/settings/profile/profile";
import Security from "../pages/settings/security/security";
import Settings from "../pages/settings/settings";
import Support from "../pages/settings/support/support";

export const PharmaPaRouteConfig = [
  { index: true, element: <PharmaPaWorklistLayout /> },
  {
    path: "pharma-pa-worklists",
    element: <PharmaPaWorklistLayout />,
    children: [
      { index: true, element: <Navigate to="pharma-pa-orders" replace /> },
      { path: "pharma-pa-orders", element: <CmmOrder /> },
      {
        path: "pharma-pa-form/:id",
        element: (
          <PharmaFormFieldsProvider>
            <PharmaPaFormLayout />
          </PharmaFormFieldsProvider>
        ),
      },
      {
        path: "pharma-pa-questionaire/:id",
        element: <PharmaQuestionaireLayout />,
      },
      {
        path: "insurance-details/:id",
        element: (
          <PharmaFormFieldsProvider>
            <InsuranceDetailsLayout />
          </PharmaFormFieldsProvider>
        ),
      },
    ],
  },
  {
    path: "pharma-pa-diff-data",
    element: <PharmaPaWorklistLayout />,
    children: [
      { index: true, element: <Navigate to="diff-data-table" replace /> },
      { path: "diff-data-table", element: <PharmaPaDiffDataLayout /> },
      {
        path: "diff-data-viewer/:id",
        element: <PharmaPaDiffViewer />,
      },
    ],
  },
  {
    path: "pharma-pa-status-internal",
    element: <InternalProcessedOrderStatus />,
  },
  {
    path: "configurations",
    element: (
      <ProtectedAdminRoute>
        <Configurations />
      </ProtectedAdminRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="documents-configuration" replace />,
      },
      { path: "documents-configuration", element: <DocumentsToAttach /> },
      { path: "rpa-configuration", element: <RpaConfiguration /> },
      {
        path: "form-configuration",
        element: <FormConfigurationLayout />,
        children: [
          { index: true, element: <Navigate to="form-config" replace /> },
          { path: "form-config", element: <FormConfig /> },
          {
            path: "form-config/:id",
            element: <SingleFormConfiguration />,
          },
        ],
      },
      {
        path: "pa-form-configuration",
        element: <PaFormConfiguration />,
      },
      {
        path: "medicine-name-configuration",
        element: <MedicineNameConfiguration />,
      },
      {
        path: "prescription-parsing-configuration",
        element: <PrescriptionParsingConfiguration />,
      },
      {
        path: "pharma-pa-configuration",
        element: <PharmaPaConfigurationLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="send-to-plan-config" replace />,
          },
          { path: "send-to-plan-config", element: <SendToPlanConfig /> },
          { path: "pbm-configurations", element: <PbmConfiguration /> },
          { path: "drugs-configuration", element: <DrugsConfiguration /> },
          { path: "clinical-questionaire", element: <ClinicalQuestionnaire /> },
        ],
      },

      {
        path: "credentials-configuration",
        element: <CredentialsConfig />,
      },
      { path: "client-configuration", element: <ClientConfiguration /> },
      { path: "provider-list", element: <ProviderList /> },
      { path: "payer-config", element: <PayerConfiguration /> },
      { path: "nar-agent-grid", element: <NarAgentGridLayout /> },
      {
        path: "health-facility",
        element: <HealthFacilityConfiguration />,
      },
    ],
  },
  {
    path: "settings",
    element: <Settings />,
    children: [
      { index: true, element: <Navigate to="profile" replace /> },
      { path: "profile", element: <Profile /> },
      { path: "security", element: <Security /> },
      { path: "members", element: <Members /> },
      { path: "support", element: <Support /> },
    ],
  },

  {
    path: "*",
    element: <ErrorPage />,
  },
];
